module.exports = __webpack_public_path__ + "static/DrukCondXXSuper-ad0cdf0302374544fabaf94637512a37.woff2";